import React from "react";
import { Translation } from "react-i18next";

export const ProfilePageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      title: <Translation>{(t) => t("navigation.main.exam_list")}</Translation>,
      path: "/student-profile/:studentId",
      exact: true,
      component: React.lazy(() => import("./studentProfile")),
    },
  ],
};
